import { useContext, useMemo } from 'react';
import UserContextProvider from 'interface/interfaces';
import * as userServices from 'service/userServices';

export function useIsLoggedIn(): boolean {
  const ctx = useContext(UserContextProvider);
  const stored = userServices.getCurrentUser?.(); // puede venir de localStorage

  // true si hay id o uid en contexto o storage
  return useMemo(() => {
    const byContext = !!ctx?.user && !!(ctx.user.id || ctx.user.uid);
    const byStored  = !!stored && !!(stored.id || stored.uid);
    return byContext || byStored;
  }, [ctx?.user, stored]);
}
